<nz-layout class="app-layout">
    <nz-sider class="menu-sidebar"
      nzCollapsible
      nzWidth="256px"
      nzBreakpoint="md"
      [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="null"
    >
      <div class="sidebar-logo">
        <a href="">
          <!-- <img src="https://ng.ant.design/assets/img/logo.svg" alt="logo"> -->
          <img src="assets/images/faith_logo.svg" alt="Logo"  />
          <!-- <h1>True Faith</h1> -->
        </a>
      </div>
      <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-menu-item nzMatchRouter routerLink="dashboard">
          <nz-icon nzType="dashboard" />
          <span >Dashboard</span>
        </li>
        <li nz-submenu  nzTitle="Churches" nzIcon="form">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="churches-list">List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="churches-add">Add</a>
            </li>
          </ul>
        </li>
        <li nz-submenu  nzTitle="Bible" nzIcon="book">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/book-master">Book Master</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/book-list">Bible List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/version-master">Versions Master List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/version-list">Versions List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/language-list">Languages List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/verse-details">Verses List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/add-verse-tag">Verses Tag</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/upload-data">Upload Verses</a>
            </li>
          </ul>
        </li>

         <li nz-submenu  nzTitle="Prayers" nzIcon="tag">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/prayer">List</a>
            </li>

            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/occasions-list">Occasions</a>
            </li>

            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/timings">Timings</a>
            </li>
            
          </ul>
        </li>

     
         <li nz-submenu  nzTitle="Groups" nzIcon="usergroup-add">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/groups">List</a>
            </li>
             
            
          </ul>
        </li>
        
        <li nz-submenu  nzTitle="CMS" nzIcon="read">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/page-add">Add </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/page-list">List </a>
            </li>
          
          </ul>
        </li>
         <li nz-submenu  nzTitle="BLOG" nzIcon="tablet">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/blog-add">Add </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/blog-list">List </a>
            </li>
          
          </ul>
        </li>
        <li nz-submenu  nzTitle="Feeds" nzIcon="red-envelope">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/feeds">Feeds List </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/saints-list">Saints Days</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/quotes-list">Quotes</a>
            </li>
             <li nz-menu-item nzMatchRouter>
              <a  routerLink="/bible-feed-list">Bible Feeds</a>
            </li>
          
          </ul>
        </li>
        <li nz-submenu  nzTitle="Enquiry" nzIcon="solution">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/enquiry-list"> List </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/enquiry-subject-list"> Subjects</a>
            </li>
          
          </ul>
        </li>

           <li nz-submenu  nzTitle="Users" nzIcon="user">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/user-list">Users List</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/user-add">Add Users</a>
            </li>
          </ul>
        </li>

         <li nz-submenu  nzTitle="Master" nzIcon="setting">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/roles-list">Roles </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/keypersonroles-list">Keyperson Roles </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a  routerLink="/modules-list">Modules </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/denominations-list">Denominations </a>
            </li>
             <li nz-menu-item nzMatchRouter>
              <a routerLink="/topics">Feeds Topics </a></li>
 
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/mood-list">Mood </a>
              </li>
  
             <li nz-menu-item nzMatchRouter>
              <a routerLink="/relationship-list">Relationship </a>
            </li>

             <li nz-menu-item nzMatchRouter>
              <a routerLink="/category-list">Category </a>
            </li>
            
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/name-list">Unique Name </a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/app-version-list">App Version</a>
            </li>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/guidelines-list"> Guidelines </a>
            </li>
             <li nz-menu-item nzMatchRouter>
              <a routerLink="/templates-list"> Templates </a>
            </li>
          </ul>
        </li>
        

        <li nz-menu-item (click)="logOut()">
          <nz-icon nzType="poweroff" nzTheme="outline" />
          <span>Logout</span>
        </li>
      </ul>
    </nz-sider>
    <nz-layout>
      <nz-header>

        <div class="app-header">
          <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
            <nz-icon class="trigger" [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'" />
          </span>
        </div>

      </nz-header>
      <nz-content>
        <div class="inner-content">
            <router-outlet />
        </div>
      </nz-content>
    </nz-layout>
  </nz-layout>
  